import React, { useState } from "react";
import SectionHeading from "./SectionHeading";
import {
  Sparkles,
  Palette,
  Code2,
  Rocket,
  CheckCircle2,
} from "lucide-react";

const processData = [
  {
    id: 1,
    title: "Discovery",
    icon: Sparkles,
    points: [
      "Requirement analysis",
      "Competitive audit",
      "Market research",
      "Goal definition",
    ],
  },
  {
    id: 2,
    title: "Design",
    icon: Palette,
    points: [
      "Wireframing",
      "UI/UX Design",
      "Prototype",
      "User Journey",
    ],
  },
  {
    id: 3,
    title: "Develop",
    icon: Code2,
    points: [
      "Frontend Development",
      "Backend APIs",
      "Database Integration",
      "Testing",
    ],
  },
  {
    id: 4,
    title: "Launch",
    icon: Rocket,
    points: [
      "Deployment",
      "Play Store",
      "App Store",
      "Maintenance",
    ],
  },
];

export default function DevelopmentProcess() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="bg-[#F8F8FB] py-20 px-6 border-t border-gray-200/60">
      <div className="max-w-5xl mx-auto">
        {/* Heading */}
        <div className="max-w-3xl mx-auto mb-12">
          <SectionHeading
            eyebrow="How We Work"
            title="Our Development Process"
            theme="light"
            titleClassName="text-[#111827]"
            showLine={false}
          />
        </div>

        {/* Tabs */}
        <div className="bg-white border border-gray-200 rounded-2xl p-2 flex flex-wrap gap-2 shadow-sm">
          {processData.map((item, index) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => setActiveTab(index)}
                className={`flex-1 min-w-[140px] flex items-center justify-center gap-2 py-3.5 rounded-xl text-sm font-semibold transition-all duration-300 ${activeTab === index
                    ? "bg-[#355dff] text-white shadow-md shadow-[#355dff]/30 scale-[1.02]"
                    : "text-gray-600 hover:text-[#355dff] hover:bg-gray-50"
                  }`}
              >
                <Icon size={17} />
                {item.title}
              </button>
            );
          })}
        </div>

        {/* Content */}
        <div className="mt-6 rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
          <div className="grid md:grid-cols-2 gap-y-4 gap-x-12">
            {processData[activeTab].points.map((point, index) => (
              <div
                key={index}
                className="flex items-center gap-3 text-gray-700 text-[15px]"
              >
                <CheckCircle2
                  className="text-[#355dff] shrink-0"
                  size={18}
                />
                <span>{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}